var render, staticRenderFns
import script from "./CrtLogin.vue?vue&type=script&lang=js&"
export * from "./CrtLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd27c44')) {
      api.createRecord('5bd27c44', component.options)
    } else {
      api.reload('5bd27c44', component.options)
    }
    
  }
}
component.options.__file = "src/views/Login/CrtLogin.vue"
export default component.exports